//****************************************************************************//
//                              CART SERVICE                                  //
//****************************************************************************//

/* ALL THE NETWORK CALLS MADE TO UPDATE OR RETRIEVE CART INFORMATION SHOULD GO HERE */

import { setCart } from '../actions/actionCreators';

import { NETWORK_URLS } from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class CartService {

  static cartData = async (token) => {
    try {
      const response = await fetch(
        `${apiUrl()}${NETWORK_URLS.get_carts}/${token}`
      );
      const json = await response.json();
      return json;
    }

    catch (e) {
      console.log(e)
      return [];
    }
  }

  static updateShippingAddress = async (shippingAddress, token) => {
    shippingAddress.token = token;
    let url = apiUrl() + (NETWORK_URLS.update_shipping_address.replace('cart_token', token));

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headerHelper(token),
        body: JSON.stringify(shippingAddress),
      });
      const json = await response.json();

      return json;
    }

    catch (e) {
      console.log(e)
      return { error: e };
    }
  }

  static updateBillingAddress = async (billingAddress, token) => {
    billingAddress.token = token;
    let url = apiUrl() + (NETWORK_URLS.update_billing_address.replace('cart_token', token));

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headerHelper(token),
        body: JSON.stringify(billingAddress),
      });
      const json = await response.json();

      return { status: response.status, json: json };
    }

    catch (e) {
      console.log(e)
      return { error: e };
    }
  }

  static createPayment = async (payment, token) => {
    payment.token = token;
    let url = apiUrl() + (NETWORK_URLS.create_payment.replace('cart_token', token));

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headerHelper(token),
        body: JSON.stringify(payment),
      });
      const json = await response.json();
      return { status: response.status, json: json };
    }

    catch (e) {
      console.log(e)
      return e
    }
  }

  static updateDelivery = async (delivery, token) => {
    let url = apiUrl() + (NETWORK_URLS.update_delivery.replace('cart_token', token));
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headerHelper(token),
        body: JSON.stringify(delivery),
      });
      const json = await response.json();

      return json;
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  }

  static updateCustomer = async (customer, token) => {
    let url = apiUrl() + (NETWORK_URLS.update_customer.replace('cart_token', token));
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headerHelper(token),
        body: JSON.stringify(customer),
      });
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  }

  static removeCreditCard = async (cardToken, token) => {
    let url = apiUrl() + (NETWORK_URLS.remove_credit_card.replace('cart_token', token));
    url = url.replace('credit_card_token', cardToken);
    try {
      const response = await fetch(url, {
        method: 'DELETE',
        headers: headerHelper(token),
      });
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  }

  static removeCreditCard = async (cardToken, token) => {
    let url = apiUrl() + (NETWORK_URLS.remove_credit_card.replace('cart_token', token));
    url = url.replace('credit_card_token', cardToken);
    try {
      const response = await fetch(url, {
        method: 'DELETE',
        headers: headerHelper(token),
      });
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  }

  static updateNote = async (note, token) => {
    let url = apiUrl() + NETWORK_URLS.cart

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headerHelper(token),
        body: JSON.stringify(note),
      });
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  };

  static updateLineItems = async (lineItems, token) => {
    let url = apiUrl() + NETWORK_URLS.cart + "/" + token;
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: headerHelper(token),
        body: JSON.stringify(lineItems),
      });
      const json = await response.json();
      return { json: json, status: response.status };
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  };

  static updateShopifyCartAttribute = async (data) => {
    try {
      const response = await fetch('/cart/update.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST'
      })
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e)
      return { error: e };
    }
  }
};
